import { useUser } from '@clerk/clerk-react';

export function useAdmin() {
  const { user, isLoaded } = useUser();
  const isAdmin =
    isLoaded === true &&
    (user?.publicMetadata as Record<string, unknown> | undefined)?.role === 'admin';
  return { isAdmin, isLoaded };
}
